import React from 'react';
import Eyebrow from './Eyebrow';
import LinkArrow from './LinkArrow';

/**
 * `.head-row` — surtitre optionnel, titre sur deux lignes dont la seconde est
 * mise en couleur, sous-titre et lien optionnels.
 *
 * Le titre arrive découpé (`{ line1, highlight }`) plutôt qu'en HTML : la
 * maquette écrivait `Canon.<br><em>À prix canon.</em>` en dur, ce qui obligerait
 * à un `dangerouslySetInnerHTML` pour du décoratif. Le `<em>` de la maquette ne
 * porte aucune emphase sémantique, seulement une couleur — c'est un `<span>` ici
 * (plan §13 Phase 3), à rendu strictement identique puisque la règle CSS
 * `.section-title em` est doublée sur `.section-title .hl`.
 */
const SectionHead = ({
  eyebrow,
  eyebrowVariant,
  title,
  subtitle,
  link,
  centered = false,
  headingLevel: Heading = 'h2',
  className = '',
  children,
}) => {
  const { line1, highlight } = title || {};
  const rowStyle = centered ? { flexDirection: 'column', alignItems: 'center', textAlign: 'center' } : undefined;
  const leftStyle = centered ? { maxWidth: '100%', textAlign: 'center' } : undefined;

  return (
    <div className={['head-row', className].filter(Boolean).join(' ')} style={rowStyle}>
      <div className="left" style={leftStyle}>
        {eyebrow && <Eyebrow variant={eyebrowVariant}>{eyebrow}</Eyebrow>}
        {(line1 || highlight) && (
          <Heading className="section-title">
            {line1}
            {line1 && highlight && <br />}
            {highlight && <span className="hl">{highlight}</span>}
          </Heading>
        )}
        {subtitle && (
          <p className="section-sub" style={centered ? { margin: '0 auto' } : undefined}>
            {subtitle}
          </p>
        )}
        {children}
      </div>
      {link && <LinkArrow href={link.href}>{link.label}</LinkArrow>}
    </div>
  );
};

export default SectionHead;
